import React, { useState } from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { useDispatch } from "react-redux";
import { deleteList } from "../../../../store/actions/leads-list";

const DeleteListModal = ({ preview, previewHandler, selectedData, successHandler }) => {
  // STATES
  const [deleteLoader, setdeleteLoader] = useState(false);
  
  // CONST VALS
  const dispatch = useDispatch();
  const { http } = global.services;

  const deleteFileHandler = () => {
    setdeleteLoader(true);
    http
      .delete(`user-lead-list/${selectedData.id}`)
      .finally(() => setdeleteLoader(false))
      .then(() => {
        toast.success("List deleted successfully");
        dispatch(deleteList(selectedData.id));
        successHandler(selectedData.id);
        previewHandler();
      })
      .catch((err) => {
        const message = err?.response?.data?.error || "Something went wrong";
        toast.error(message);
      });
  };

  return (
    <Modal
      visible={preview}
      centered
      className="delete-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Delete List</h2>
      <p>
        Are you sure you want to delete <strong>{selectedData?.name}</strong> along with
        all associated leads? This action cannot be undone.
      </p>
      <div className="action-box">
        <button onClick={previewHandler}>Cancel</button>
        <button className="delete" onClick={deleteFileHandler}>
          {deleteLoader ? <BeatLoader size={8} color="#fff" /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteListModal;
